import { render, staticRenderFns } from "./EditorSettingsEdit.vue?vue&type=template&id=52b38a14&scoped=true"
import script from "./EditorSettingsEdit.vue?vue&type=script&lang=ts"
export * from "./EditorSettingsEdit.vue?vue&type=script&lang=ts"
import style0 from "./EditorSettingsEdit.vue?vue&type=style&index=0&id=52b38a14&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b38a14",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52b38a14')) {
      api.createRecord('52b38a14', component.options)
    } else {
      api.reload('52b38a14', component.options)
    }
    module.hot.accept("./EditorSettingsEdit.vue?vue&type=template&id=52b38a14&scoped=true", function () {
      api.rerender('52b38a14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/reminder-layout-editor/EditorSettingsEdit.vue"
export default component.exports